module.exports = __webpack_public_path__ + "img/star-active-icon.640798f3.svg";